import React from "react";
import {Button, Modal, ModalBody, ModalFooter} from "reactstrap";
import {Aux, isNullEmptyOrWhitespace} from "../../constants";
import ReactSwipe from "react-swipe";
import {apiRequest} from "../../utils/request";
import PropTypes from 'prop-types';

class PickupImageViewer extends React.Component {
    constructor(props, context) {
        super(props, context);
        
        this.state = {
            images: [],
            currentImage: '',
            modal: false,
        };

        this.toggle = this.toggle.bind(this);        
        this.swipRef = React.createRef();
    }    

    toggle() {
        let isOpening = !this.state.modal;
        let {pickup} = this.props;

        this.setState({images: [], currentImage: ''});
        if(isOpening){
            apiRequest(`/api/runs/pickupImages?locationId=${pickup.locationID}&isDelivery=${!!this.props.isDelivery}`)
                .then(x => {
                    let images = x.data.map(i => `data:image/jpeg;base64,${i.image}`);
                    this.setState({images, currentImage: images.length > 0 ? images[0] : ''});
                });
        }

        this.setState({
            modal: !this.state.modal
        });
    }
    
    render() {

        let {pickup} = this.props;

        return (pickup.locationImageCount > 0 ?
            <Aux>
                <Button onClick={this.toggle} color="info"><i className="fa fa-picture-o fa-3x"/></Button>
                <Modal isOpen={this.state.modal}
                       toggle={this.toggle}                           
                       zIndex={10000000000}>
                    <ModalBody>
                        {!isNullEmptyOrWhitespace(this.state.currentImage) ?
                            <ReactSwipe className="carousel" swipeOptions={{continuous: true}}
                                        ref={this.swipRef}>
                                {this.state.images.map(i => {
                                    return (
                                        <div key={i}><img className="d-block img-fluid w-100" src={i}/></div>);
                                })}
                            </ReactSwipe>
                            :
                            <h4><i className="fa fa-cog fa-spin"/></h4>}
                    </ModalBody>
                    <ModalFooter>
                        <div className="row">
                            <div className="col-12">
                                {
                                    this.state.images.map((i, index) => {
                                        return (
                                            <img src={i} className="img-thumbnail w-25" key={i} onClick={(e) => this.swipRef.current.slide(index)}
                                            />
                                        );
                                    })}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 col-xs-12">
                                <Button color="secondary" onClick={this.toggle}>Close</Button>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>
            </Aux> : null);
    }
}

PickupImageViewer.propTypes = {    
    pickup: PropTypes.object.isRequired,
};

export default PickupImageViewer;